import React from "react";
import PropTypes from "prop-types";
import "../../styles.scss";

import HeaderItem from "./HeaderItem";
import ColumnSpacer from "../ColumnSpacer";

const Header = ({
  headerGroups,
  sortableColumns,
  setResizer,
  resizer,
  stretchColumnWidth,
}) => (
  <thead>
    {headerGroups.map((headerGroup, index) => (
      <tr
        {...headerGroup.getHeaderGroupProps()}
        key={index}
        onMouseUp={() => resizer && setResizer(false)}
      >
        {headerGroup.headers.map(column => (
          <HeaderItem
            sortableColumns={sortableColumns}
            setResizer={setResizer}
            column={column}
            key={column.id}
          />
        ))}
        {!stretchColumnWidth && <ColumnSpacer as="th" />}
      </tr>
    ))}
  </thead>
);

Header.propTypes = {
  headerGroups: PropTypes.array,
  sortableColumns: PropTypes.array,
  setResizer: PropTypes.func,
  resizer: PropTypes.bool,
  stretchColumnWidth: PropTypes.bool,
};

export default Header;
